"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeUrlToCosmosTransformer = exports.getAuthInfoJson = exports.getTxBodyJson = exports.getSignaturesJson = exports.getSignerInfoJson = exports.TxDecoder = void 0;
var proto_signing_1 = require("@cosmjs/proto-signing");
var encoding_1 = require("@cosmjs/encoding");
var tx_1 = require("@cosmjs/proto-signing/build/codec/cosmos/tx/v1beta1/tx");
var snakecaseKeys = __importStar(require("snakecase-keys"));
var long_1 = __importDefault(require("long"));
var codecimpl_1 = require("../cosmos/v1beta1/codec/generated/codecimpl");
var bytes_1 = require("./bytes/bytes");
var typeurls_1 = require("../cosmos/v1beta1/types/typeurls");
var typeurl_1 = require("../transaction/common/constants/typeurl");
var timestamp_1 = require("./timestamp");
var cosmJSRegistry = new proto_signing_1.Registry(Object.entries(typeurls_1.typeUrlMappings));
var TxDecoder = (function () {
    function TxDecoder() {
        this.assertHex = function (h) {
            var re = /^[a-fA-F0-9]+$/;
            if (!re.test(h)) {
                throw new TypeError('Invalid Hex provided.');
            }
        };
        this.libDecodedTxBody = Object.create({});
        this.libDecodedAuthInfo = Object.create({});
        this.libDecodedSignatures = Object.create([]);
    }
    TxDecoder.prototype.fromHex = function (txHex) {
        if (!txHex) {
            throw new TypeError("Received malformed transaction hex.");
        }
        this.assertHex(txHex);
        var sanitisedTxHex = bytes_1.Bytes.clean0x(txHex);
        try {
            var encodedTxBytes = bytes_1.Bytes.fromHexString(sanitisedTxHex).toUint8Array();
            var libDecodedTx = tx_1.Tx.decode(encodedTxBytes);
            this.libDecodedSignatures = libDecodedTx.signatures;
            this.libDecodedAuthInfo = libDecodedTx.authInfo;
            this.libDecodedTxBody = libDecodedTx.body;
            return this;
        }
        catch (error) {
            throw new TypeError("Error decoding provided transaction hex.");
        }
    };
    TxDecoder.prototype.toCosmosJSON = function () {
        var txObject = {
            body: Object.create({}),
            authInfo: Object.create({}),
            signatures: Object.create([[]]),
        };
        txObject.body = exports.getTxBodyJson(this.libDecodedTxBody);
        txObject.signatures = exports.getSignaturesJson(this.libDecodedSignatures);
        txObject.authInfo = exports.getAuthInfoJson(this.libDecodedAuthInfo);
        var stringifiedTx = JSON.stringify(snakecaseKeys.default(txObject));
        var cosmosApiFormatTxJson = exports.typeUrlToCosmosTransformer(stringifiedTx);
        return cosmosApiFormatTxJson;
    };
    return TxDecoder;
}());
exports.TxDecoder = TxDecoder;
exports.getSignerInfoJson = function (signerInfo) {
    var _a, _b, _c;
    var stringifiedSignerInfo = JSON.stringify(tx_1.SignerInfo.toJSON(signerInfo));
    var libParsedSignerInfo = JSON.parse(stringifiedSignerInfo);
    var decodedPubkey = cosmJSRegistry.decode({
        typeUrl: (_a = libParsedSignerInfo.publicKey) === null || _a === void 0 ? void 0 : _a.typeUrl,
        value: encoding_1.fromBase64((_b = libParsedSignerInfo.publicKey) === null || _b === void 0 ? void 0 : _b.value),
    });
    var obj = __assign({}, libParsedSignerInfo);
    obj.publicKey = { typeUrl: (_c = libParsedSignerInfo.publicKey) === null || _c === void 0 ? void 0 : _c.typeUrl, key: encoding_1.toBase64(decodedPubkey.key) };
    return obj;
};
exports.getSignaturesJson = function (signaturesArray) {
    var signatures = [];
    if (signaturesArray) {
        signatures = signaturesArray.map(function (e) { return encoding_1.toBase64(typeof e !== typeof undefined ? e : new Uint8Array()); });
    }
    return signatures;
};
exports.getTxBodyJson = function (txBody) {
    var txBodyStringified = JSON.stringify(tx_1.TxBody.toJSON(txBody));
    var parsedTxBody = JSON.parse(txBodyStringified);
    var obj = __assign({}, parsedTxBody);
    obj.messages = txBody.messages.map(function (_a) {
        var typeUrl = _a.typeUrl, value = _a.value;
        return decodeAnyType(typeUrl, value);
    });
    return obj;
};
function decodeAnyType(typeUrl, value) {
    if (!typeUrl) {
        throw new Error('Missing type_url in Any');
    }
    if (!value) {
        throw new Error('Missing value in Any');
    }
    var decodedParams = cosmJSRegistry.decode({ typeUrl: typeUrl, value: value });
    handleCustomTypes(decodedParams);
    var finalDecodedParams = handleSpecialParams(decodedParams, typeUrl);
    return __assign({ typeUrl: typeUrl }, finalDecodedParams);
}
function handleSpecialParams(decodedParams, typeUrl) {
    var clonedDecodedParams = __assign({}, decodedParams);
    if (decodedParams.content && Object.keys(decodedParams.content).length !== 0) {
        clonedDecodedParams.content = decodeAnyType(decodedParams.content.type_url, decodedParams.content.value);
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.MsgCreateValidator) {
        clonedDecodedParams.pubkey = decodeAnyType(decodedParams.pubkey.type_url, decodedParams.pubkey.value);
        clonedDecodedParams.pubkey.key = bytes_1.Bytes.fromUint8Array(clonedDecodedParams.pubkey.key).toBase64String();
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.MsgEditValidator) {
        if (decodedParams.commissionRate === '' || typeof decodedParams.commissionRate === 'undefined') {
            clonedDecodedParams.commissionRate = null;
        }
        if (decodedParams.minSelfDelegation === '' || typeof decodedParams.minSelfDelegation === 'undefined') {
            clonedDecodedParams.minSelfDelegation = null;
        }
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgCreateClient) {
        if (decodedParams.clientState && Object.keys(decodedParams.clientState).length > 0) {
            clonedDecodedParams.clientState = decodeAnyType(decodedParams.clientState.type_url, decodedParams.clientState.value);
            if (clonedDecodedParams.clientState.trustingPeriod &&
                clonedDecodedParams.clientState.trustingPeriod.seconds) {
                clonedDecodedParams.clientState.trustingPeriod = clonedDecodedParams.clientState.trustingPeriod.seconds + "s";
            }
            if (clonedDecodedParams.clientState.unbondingPeriod &&
                clonedDecodedParams.clientState.unbondingPeriod.seconds) {
                clonedDecodedParams.clientState.unbondingPeriod = clonedDecodedParams.clientState.unbondingPeriod.seconds + "s";
            }
            if (clonedDecodedParams.clientState.maxClockDrift &&
                clonedDecodedParams.clientState.maxClockDrift.seconds) {
                clonedDecodedParams.clientState.maxClockDrift = clonedDecodedParams.clientState.maxClockDrift.seconds + "s";
            }
            if (clonedDecodedParams.clientState.proofSpecs && clonedDecodedParams.clientState.proofSpecs.length > 0) {
                clonedDecodedParams.clientState.proofSpecs = clonedDecodedParams.clientState.proofSpecs.map(function (proofSpec) {
                    if (proofSpec.leafSpec) {
                        if (proofSpec.leafSpec.hash) {
                            proofSpec.leafSpec.hash = getHashOpStringFromValue(proofSpec.leafSpec.hash);
                        }
                        if (proofSpec.leafSpec.prehashKey) {
                            proofSpec.leafSpec.prehashKey = getHashOpStringFromValue(proofSpec.leafSpec.prehashKey);
                        }
                        if (proofSpec.leafSpec.prehashValue) {
                            proofSpec.leafSpec.prehashValue = getHashOpStringFromValue(proofSpec.leafSpec.prehashValue);
                        }
                        if (proofSpec.leafSpec.length) {
                            proofSpec.leafSpec.length = getLengthOpStringFromValue(proofSpec.leafSpec.length);
                        }
                        if (proofSpec.leafSpec.prefix) {
                            proofSpec.leafSpec.prefix = bytes_1.Bytes.fromUint8Array(proofSpec.leafSpec.prefix).toBase64String();
                        }
                    }
                    if (proofSpec.innerSpec) {
                        proofSpec.innerSpec.emptyChild = null;
                        if (proofSpec.innerSpec.hash) {
                            proofSpec.innerSpec.hash = getHashOpStringFromValue(proofSpec.innerSpec.hash);
                        }
                    }
                    return proofSpec;
                });
            }
        }
        if (decodedParams.consensusState && Object.keys(decodedParams.consensusState).length > 0) {
            clonedDecodedParams.consensusState = decodeAnyType(decodedParams.consensusState.type_url, decodedParams.consensusState.value);
            if (clonedDecodedParams.consensusState.nextValidatorsHash) {
                clonedDecodedParams.consensusState.nextValidatorsHash = bytes_1.Bytes.fromUint8Array(clonedDecodedParams.consensusState.nextValidatorsHash).toHexString();
            }
        }
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.ibc.MsgUpdateClient) {
        if (decodedParams.header && Object.keys(decodedParams.header).length > 0) {
            clonedDecodedParams.header = decodeAnyType(decodedParams.header.type_url, decodedParams.header.value);
            if (clonedDecodedParams.header.signedHeader) {
                var signedHeader = clonedDecodedParams.header.signedHeader;
                if (signedHeader.header) {
                    if (signedHeader.header.time) {
                        clonedDecodedParams.header.signedHeader.header.time = timestamp_1.convertSecondsNanosToTZFormat(long_1.default.fromString(signedHeader.header.time.seconds), signedHeader.header.time.nanos);
                    }
                    if (signedHeader.header.lastBlockId.hash) {
                        clonedDecodedParams.header.signedHeader.header.lastBlockId.hash = bytes_1.Bytes.fromUint8Array(signedHeader.header.lastBlockId.hash).toBase64String();
                    }
                    if (signedHeader.header.lastBlockId.partSetHeader.hash) {
                        clonedDecodedParams.header.signedHeader.header.lastBlockId.partSetHeader.hash = bytes_1.Bytes.fromUint8Array(signedHeader.header.lastBlockId.partSetHeader.hash).toBase64String();
                    }
                    if (signedHeader.header.lastCommitHash) {
                        clonedDecodedParams.header.signedHeader.header.lastCommitHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.lastCommitHash).toBase64String();
                    }
                    if (signedHeader.header.dataHash) {
                        clonedDecodedParams.header.signedHeader.header.dataHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.dataHash).toBase64String();
                    }
                    if (signedHeader.header.validatorsHash) {
                        clonedDecodedParams.header.signedHeader.header.validatorsHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.validatorsHash).toBase64String();
                    }
                    if (signedHeader.header.nextValidatorsHash) {
                        clonedDecodedParams.header.signedHeader.header.nextValidatorsHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.nextValidatorsHash).toBase64String();
                    }
                    if (signedHeader.header.consensusHash) {
                        clonedDecodedParams.header.signedHeader.header.consensusHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.consensusHash).toBase64String();
                    }
                    if (signedHeader.header.appHash) {
                        clonedDecodedParams.header.signedHeader.header.appHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.appHash).toBase64String();
                    }
                    if (signedHeader.header.lastResultsHash) {
                        clonedDecodedParams.header.signedHeader.header.lastResultsHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.lastResultsHash).toBase64String();
                    }
                    if (signedHeader.header.evidenceHash) {
                        clonedDecodedParams.header.signedHeader.header.evidenceHash = bytes_1.Bytes.fromUint8Array(signedHeader.header.evidenceHash).toBase64String();
                    }
                    if (signedHeader.header.proposerAddress) {
                        clonedDecodedParams.header.signedHeader.header.proposerAddress = bytes_1.Bytes.fromUint8Array(signedHeader.header.proposerAddress).toBase64String();
                    }
                }
                if (signedHeader.commit) {
                    if (signedHeader.commit.signatures && signedHeader.commit.signatures.length > 0) {
                        signedHeader.commit.signatures = signedHeader.commit.signatures.map(function (signatureObj) {
                            if (signatureObj.blockIdFlag) {
                                signatureObj.blockIdFlag = getBlockIdFlagStringFromValue(signatureObj.blockIdFlag);
                            }
                            if (signatureObj.validatorAddress) {
                                signatureObj.validatorAddress = bytes_1.Bytes.fromUint8Array(signatureObj.validatorAddress).toBase64String();
                            }
                            if (signatureObj.timestamp) {
                                signatureObj.timestamp = timestamp_1.convertSecondsNanosToTZFormat(long_1.default.fromString(signatureObj.timestamp.seconds), signatureObj.timestamp.nanos);
                            }
                            if (signatureObj.signature) {
                                signatureObj.signature = bytes_1.Bytes.fromUint8Array(signatureObj.signature).toBase64String();
                            }
                            return signatureObj;
                        });
                    }
                    if (signedHeader.commit.blockId) {
                        if (signedHeader.commit.blockId.hash) {
                            clonedDecodedParams.header.signedHeader.commit.blockId.hash = bytes_1.Bytes.fromUint8Array(clonedDecodedParams.header.signedHeader.commit.blockId.hash).toBase64String();
                        }
                        if (signedHeader.commit.blockId.partSetHeader &&
                            signedHeader.commit.blockId.partSetHeader.hash) {
                            clonedDecodedParams.header.signedHeader.commit.blockId.partSetHeader.hash = bytes_1.Bytes.fromUint8Array(clonedDecodedParams.header.signedHeader.commit.blockId.partSetHeader.hash).toBase64String();
                        }
                    }
                }
            }
            if (clonedDecodedParams.header.validatorSet && clonedDecodedParams.header.validatorSet) {
                var validatorSet = clonedDecodedParams.header.validatorSet;
                if (validatorSet.validators && validatorSet.validators.length > 0) {
                    validatorSet.validators = validatorSet.validators.map(function (validator) {
                        if (validator.address) {
                            validator.address = bytes_1.Bytes.fromUint8Array(validator.address).toBase64String();
                        }
                        if (validator.pubKey) {
                            if (validator.pubKey.ed25519) {
                                validator.pubKey.ed25519 = bytes_1.Bytes.fromUint8Array(validator.pubKey.ed25519).toBase64String();
                            }
                            if (validator.pubKey.secpk256) {
                                validator.pubKey.secpk256 = bytes_1.Bytes.fromUint8Array(validator.pubKey.secpk256).toBase64String();
                            }
                        }
                        return validator;
                    });
                }
                if (validatorSet.proposer) {
                    if (validatorSet.proposer.address) {
                        clonedDecodedParams.header.validatorSet.proposer.address = bytes_1.Bytes.fromUint8Array(clonedDecodedParams.header.validatorSet.proposer.address).toBase64String();
                    }
                    if (validatorSet.proposer.pubKey) {
                        if (validatorSet.proposer.pubKey.ed25519) {
                            clonedDecodedParams.header.validatorSet.proposer.pubKey.ed25519 = bytes_1.Bytes.fromUint8Array(validatorSet.proposer.pubKey.ed25519).toBase64String();
                        }
                    }
                }
            }
            if (clonedDecodedParams.header.trustedValidators) {
                var trustedValidators = clonedDecodedParams.header.trustedValidators;
                if (trustedValidators.validators && trustedValidators.validators.length > 0) {
                    trustedValidators.validators = trustedValidators.validators.map(function (validator) {
                        if (validator.address) {
                            validator.address = bytes_1.Bytes.fromUint8Array(validator.address).toBase64String();
                        }
                        if (validator.pubKey) {
                            if (validator.pubKey.ed25519) {
                                validator.pubKey.ed25519 = bytes_1.Bytes.fromUint8Array(validator.pubKey.ed25519).toBase64String();
                            }
                            if (validator.pubKey.secpk256) {
                                validator.pubKey.secpk256 = bytes_1.Bytes.fromUint8Array(validator.pubKey.secpk256).toBase64String();
                            }
                        }
                        return validator;
                    });
                }
                if (trustedValidators.proposer.address) {
                    clonedDecodedParams.header.trustedValidators.proposer.address = bytes_1.Bytes.fromUint8Array(trustedValidators.proposer.address).toBase64String();
                }
                if (trustedValidators.proposer.pubKey) {
                    if (trustedValidators.proposer.pubKey.ed25519) {
                        clonedDecodedParams.header.trustedValidators.proposer.pubKey.ed25519 = bytes_1.Bytes.fromUint8Array(trustedValidators.proposer.pubKey.ed25519).toBase64String();
                    }
                }
            }
        }
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.ibc.connection.MsgConnectionOpenConfirm) {
        if (decodedParams.proofAck) {
            clonedDecodedParams.proofAck = bytes_1.Bytes.fromUint8Array(decodedParams.proofAck).toBase64String();
        }
    }
    if (typeUrl === typeurl_1.COSMOS_MSG_TYPEURL.ibc.connection.MsgConnectionOpenTry) {
        if (decodedParams.counterparty.prefix && decodedParams.counterparty.prefix.keyPrefix) {
            clonedDecodedParams.counterparty.prefix.keyPrefix = bytes_1.Bytes.fromUint8Array(decodedParams.counterparty.prefix.keyPrefix).toBase64String();
        }
        if (decodedParams.proofInit) {
            clonedDecodedParams.proofInit = bytes_1.Bytes.fromUint8Array(decodedParams.proofInit).toBase64String();
        }
        if (decodedParams.proofClient) {
            clonedDecodedParams.proofClient = bytes_1.Bytes.fromUint8Array(decodedParams.proofClient).toBase64String();
        }
        if (decodedParams.proofConsensus) {
            clonedDecodedParams.proofConsensus = bytes_1.Bytes.fromUint8Array(decodedParams.proofConsensus).toBase64String();
        }
    }
    return clonedDecodedParams;
}
var getHashOpStringFromValue = function (targetValue) {
    var mayBeHashOp = Object.values(codecimpl_1.ics23.HashOp).find(function (v) { return v === targetValue; });
    if (mayBeHashOp) {
        return codecimpl_1.ics23.HashOp[mayBeHashOp] || null;
    }
    return null;
};
var getLengthOpStringFromValue = function (targetValue) {
    var mayBeLengthOp = Object.values(codecimpl_1.ics23.LengthOp).find(function (v) { return v === targetValue; });
    if (mayBeLengthOp) {
        return codecimpl_1.ics23.LengthOp[mayBeLengthOp] || null;
    }
    return null;
};
var getBlockIdFlagStringFromValue = function (targetValue) {
    var mayBeBlockIdFlag = Object.values(codecimpl_1.tendermintV2.types.BlockIDFlag).find(function (v) { return v === targetValue; });
    if (mayBeBlockIdFlag) {
        return codecimpl_1.tendermintV2.types.BlockIDFlag[mayBeBlockIdFlag] || null;
    }
    return null;
};
exports.getAuthInfoJson = function (authInfo) {
    var authInfoStringified = JSON.stringify(tx_1.AuthInfo.toJSON(authInfo));
    var libParsedAuthInfo = JSON.parse(authInfoStringified);
    var obj = __assign({}, libParsedAuthInfo);
    if (authInfo.signerInfos) {
        obj.signerInfos = authInfo.signerInfos.map(function (e) {
            return typeof e !== typeof undefined ? exports.getSignerInfoJson(e) : undefined;
        });
    }
    else {
        obj.signerInfos = [];
    }
    return obj;
};
exports.typeUrlToCosmosTransformer = function (str) { return str.replace(/type_url/g, '@type'); };
var handleCustomTypes = function (obj) {
    Object.keys(obj).forEach(function (k) {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
            if (obj[k] instanceof long_1.default) {
                obj[k] = obj[k].toString(10);
            }
            handleCustomTypes(obj[k]);
        }
    });
};
//# sourceMappingURL=txDecoder.js.map